import React from 'react';
import { TouchableOpacity, Text, StyleSheet, Platform } from 'react-native';
import PlatformIcon from '../common/PlatformIcon';

export interface DiscoverFABProps {
  /**
   * 点击回调
   */
  onPress: () => void;
  
  /**
   * 图标名称（MaterialIcons）
   */
  icon?: string;
  
  /**
   * 按钮文字
   */
  text?: string;
  
  /**
   * 按钮背景色
   */
  backgroundColor?: string;
  
  /**
   * 按钮文字颜色
   */
  textColor?: string;
}

/**
 * 发现旅行悬浮按钮组件
 * 
 * 用于快速访问发现页面的 FAB 按钮
 * 
 * @example
 * ```tsx
 * <DiscoverFAB
 *   onPress={() => navigation.navigate('DiscoverTravels')}
 *   icon="explore"
 *   text="发现"
 * />
 * ```
 */
export const DiscoverFAB: React.FC<DiscoverFABProps> = ({
  onPress,
  icon = 'explore',
  text = '发现',
  backgroundColor = '#FF7043',
  textColor = '#fff',
}) => {
  return (
    <TouchableOpacity
      style={[styles.fab, { backgroundColor }]}
      onPress={onPress}
      activeOpacity={0.8}
    >
  <PlatformIcon name={icon} size={20} color={textColor} family="MaterialIcons" />
      <Text style={[styles.fabText, { color: textColor }]}>{text}</Text>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  fab: {
    position: 'absolute',
    right: 16,
    bottom: 24,
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderRadius: 24,
    ...Platform.select({
      web: { elevation: 4 as any, boxShadow: '0 2px 8px rgba(0,0,0,0.12)' },
      default: { elevation: 4, shadowColor: '#000', shadowOffset: { width: 0, height: 2 }, shadowOpacity: 0.25, shadowRadius: 4 },
    }),
  },
  fabText: {
    fontSize: 14,
    fontWeight: 'bold',
    marginLeft: 8,
  },
});
